export default __webpack_public_path__ + "static/media/meal-log.7110737f.svg";